import { render, staticRenderFns } from "./ProductItemVariationList.vue?vue&type=template&id=950cdad6&scoped=true"
import script from "./ProductItemVariationList.vue?vue&type=script&lang=js"
export * from "./ProductItemVariationList.vue?vue&type=script&lang=js"
import style0 from "./ProductItemVariationList.vue?vue&type=style&index=0&id=950cdad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950cdad6",
  null
  
)

export default component.exports